import { DynamicEmbeddedWidget } from '@dynamic-labs/sdk-react-core'

const Login: React.FC = () => {
  return (
    <div className='pt-9 p-[33px] pb-[35px] w-[400px] h-full'>
      <DynamicEmbeddedWidget background='default' />
    </div>
  )
}

export default Login
